import { useState } from "react";

/**
 * Simple hook to remember which couple (by node id) is currently expanded.
 * If `expandedId` is undefined the tree shows only the default three generations.
 */
export default function useCoupleExpansion() {
  const [expandedId, setExpandedId] = useState<string | undefined>(undefined);
  const [token, setToken] = useState(0);

  const expand = (id: string) => {
    setExpandedId((prev) => {
      if (prev === id) {
        // collapse
        return undefined;
      }
      // expand new
      return id;
    });
    setToken((t) => t + 1);
  };
  const reset = () => setExpandedId(undefined);

  return { expandedId, token, expand, reset };
}
